/** Settings > Integrations: ang Zoho CRM card at ang pagbalik mula sa consent screen ng Zoho. Merged into `settings.integrations.zoho`. */
export const settingsZoho = {
  name: "Zoho CRM",
  description: "Ipinapadala sa Zoho CRM bilang Lead ang bawat bagong lead mula sa iyong assistant, kaya nasa tool na ginagamit ng sales team ninyo.",
  connect: "Ikonekta ang Zoho CRM",
  reconnect: "Ikonekta ulit ang Zoho CRM",
  redirecting: "Lilipat sa Zoho…",
  connectNote: "Mag-sign in ka sa Zoho at papayagan ang {{product}} na magdagdag at mag-update ng mga Lead. Wala itong access sa iba mong module sa Zoho CRM, at maaari mo itong idiskonekta anumang oras.",
  unavailable: "Hilingin sa platform team na i-set up ang Zoho CRM.",
  notConfigured: "Hindi pa naka-set up ang Zoho CRM para sa platform na ito. Makipag-ugnayan sa platform team.",
  loadErrorTitle: "Hindi namin ma-load ang Zoho CRM",
  readOnly: "Humingi ng tulong sa isang admin para pamahalaan ang integration na ito.",
  statusReconnect: "Kailangang ikonekta ulit",
  connectedBody: "Ipinapadala sa Zoho CRM bilang Lead ang mga bagong lead.",
  reconnectBody: "Hindi na tinatanggap ng Zoho ang access ng {{product}} (maaaring inalis ito sa Zoho). Hindi naipapadala ang mga bagong lead hangga't hindi mo ito ikinokonekta ulit.",
  region: "Rehiyon ng Zoho",
  regionAutomatic: "Awtomatiko (inirerekomenda)",
  regionHint: "Awtomatikong hinahanap ang data center ng iyong account kapag nag-sign in ka sa Zoho. Pumili lang ng rehiyon kung alam mo ang sa iyo.",
  details: {
    account: "Email ng account",
    organization: "Organisasyon",
    datacenter: "Data center",
    lastSync: "Huling sync",
    noSync: "Wala pang sync",
    syncResult: "{{date}} · {{synced}} ang na-sync, {{failed}} ang hindi tinanggap",
  },
  disconnect: {
    title: "Idiskonekta ang Zoho CRM?",
    body: "Titigil ang {{product}} sa pagpapadala ng mga lead at aalisin nito ang access nito sa Zoho. Mananatili sa Zoho ang mga lead na nandoon na.",
    confirm: "Idiskonekta",
    done: "Nadiskonekta ang Zoho CRM",
  },
  returned: {
    connected: "Nakakonekta na ang Zoho CRM. Ipapadala na sa Zoho ang mga bagong lead.",
    reasons: {
      denied: "Hindi mo pinayagan ang access sa Zoho.",
      expired: "Nag-expire na ang pagtatangkang ito. Magsimula ulit.",
      failed: "Hindi tinanggap ng Zoho ang koneksyon. Subukan ulit.",
      no_refresh: "Hindi nagbigay ang Zoho ng pangmatagalang access. Sa Zoho > Settings > Connected Apps, alisin ang {{product}}, tapos ikonekta ulit.",
      scope: "Kailangan ng {{product}} ng pahintulot para magdagdag ng lead sa Zoho. Ikonekta ulit at panatilihing naka-tick ang lahat ng kahon.",
      unavailable: "Hindi pa naka-set up ang Zoho CRM para sa platform na ito. Makipag-ugnayan sa platform team.",
      forbidden: "Wala ka nang pahintulot na pamahalaan ang mga integration.",
    },
  },
  contactsSync: {
    "title": "Mga contact at account sa Zoho",
    "subtitle": "Ang Sagot ang tala ng support; ang Zoho CRM ang pinagmumulan.",
    "proposed": "Iminumungkahi",
    "tableCaption": "Ang pinapanatiling magkatugma sa Zoho CRM",
    "tableRecords": "Mga talaan",
    "tableDirection": "Direksyon",
    "tableLinked": "Naka-link",
    "tableStatus": "Katayuan",
    "contactsRow": "Mga contact",
    "contactsHint": "Mga tao, kasama ang Zoho Contacts",
    "accountsRow": "Mga account",
    "accountsHint": "Mga organisasyon, kasama ang Zoho Accounts",
    "linkedCount_one": "{{count}} naka-link",
    "linkedCount_other": "{{count}} naka-link",
    "deletedInZoho_one": "{{count}} binura sa Zoho",
    "deletedInZoho_other": "{{count}} binura sa Zoho",
    "statusOn": "Nagsi-sync",
    "statusOff": "Naka-off",
    "switchLabel": "I-sync ang mga contact at account",
    "switchHint": "Binabasa ang Zoho kada 15 minuto at ipinapadala ang mga pagbabago mo. Ang binurang record sa Zoho ay ina-archive dito, hindi tinatanggal.",
    "needsScopesTitle": "Ikonekta ulit para payagan ang access sa Contacts at Accounts",
    "needsScopesBody": "Ang Zoho CRM ay nakakonekta para sa mga lead lang. Ikonekta ulit ito at panatilihing may check ang Contacts at Accounts para mabasa at maisulat ito ng sync na ito. Hindi apektado ang lead sync mo.",
    "needsScopesButton": "Ikonekta ulit ang Zoho CRM",
    "needsScopesHint": "Ikonekta muna ulit ang Zoho CRM (tingnan sa itaas).",
    "needsZoho": "Ikonekta muna ang Zoho CRM sa itaas.",
    "directionLabel": "Direksyon",
    "rule": "Ang customer reference, tier at account status ay ipinapadala lang sa Zoho: walang makakapagbago sa mga ito mula sa Zoho. Kapag parehong nagbago ang isang record, panalo ang Zoho. Nasa audit log ang bawat pagbabago.",
    "mapping": "Pagtutugma ng field",
    "syncNow": "I-sync ngayon",
    "syncing": "Nagsi-sync…",
    "noRun": "Wala pang sync.",
    "lastRun": "Huling sync:",
    "runLine": "{{date}} · {{here}} naisulat dito, {{there}} naipadala sa Zoho, {{failed}} hindi tinanggap",
    "saved": "Na-save ang mga setting ng Zoho sync",
    "ran": "Tapos na ang sync",
    "readOnly": "Magtanong sa admin para pamahalaan ang integration na ito.",
    "loadErrorTitle": "Hindi namin ma-load ang Zoho contacts sync",
    "directions": {
      "both": "Dalawang direksyon",
      "from_zoho": "Zoho papuntang Sagot",
      "to_zoho": "Sagot papuntang Zoho"
    },
    "runCodes": {
      "not_connected": "Hindi nakakonekta ang Zoho CRM. Ikonekta ito sa itaas.",
      "needs_reconnect": "Hindi na tinatanggap ng Zoho ang koneksyon. Ikonekta ulit ang Zoho CRM sa itaas.",
      "scope": "Hindi pinayagan ng Zoho ang access sa Contacts at Accounts. Ikonekta ulit ang Zoho CRM at payagan ang mga ito.",
      "unavailable": "Hindi sumagot ang Zoho CRM. Susubukan ulit ito sa loob ng ilang minuto.",
      "busy": "May sync na tumatakbo na. Subukan ulit mamaya.",
      "failed": "Huminto ang sync bago matapos. Susubukan ulit ito sa loob ng ilang minuto."
    },
    "fields": {
      "contact_name": "Pangalan ng contact",
      "contact_email": "Email ng contact",
      "contact_job_title": "Posisyon",
      "contact_organisation": "Organisasyon",
      "contact_customer_ref": "Customer reference",
      "contact_tier": "Tier ng customer",
      "contact_account_status": "Account status",
      "account_name": "Pangalan ng account",
      "account_industry": "Industriya",
      "account_notes": "Mga tala",
      "account_tier": "Tier ng account"
    },
    "mappingDialog": {
      "title": "Pagtutugma ng field",
      "description": "Piliin ang field sa Zoho na pinapanatiling katugma ng bawat field sa Sagot. Iwanang walang laman para hindi isama.",
      "contactGroup": "Mga contact",
      "accountGroup": "Mga account",
      "sendOnly": "Ipinapadala lang sa Zoho",
      "notMapped": "Hindi nakatugma",
      "problemName": "Gumamit ng letra, numero at underscore, at magsimula sa letra.",
      "problemDuplicate": "Ginagamit na ng ibang field ang field na ito sa Zoho.",
      "referenceHint": "Ang mga field na may “Ipinapadala lang sa Zoho” ay hindi kailanman binabago mula sa Zoho. Kailangan ng pahintulot na makita ang customer reference para itugma ito.",
      "reset": "Mga karaniwang field",
      "save": "I-save ang pagtutugma",
      "saving": "Sine-save…"
    }
  },
};
